export const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'The Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo, Democratic Republic of the',
  'Congo, Republic of the',
  'Costa Rica',
  'Côte d’Ivoire',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor (Timor-Leste)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'The Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, North',
  'Korea, South',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar (Burma)',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Sudan, South',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
]
export const institutionOptions = [
  '0-High School',
  '0-Not Available',
  'Abilene Christian University',
  'Adelphi University',
  'Adirondack Community College',
  'Aims Community College',
  'Air Force Institute of Technology',
  'Alabama A&amp;M University',
  'Albertus Magnus College',
  'Albion College',
  'Albright College',
  'Alfred University',
  'Allegheny College',
  'Alvernia College',
  'Amberton University at Dallas',
  'American College of Technology',
  'American InterContinental University',
  'American River College',
  'American University',
  'Ankara University',
  'Anna University',
  'Annamalai University',
  'Anne Arundel Community College',
  'Antelope Valley Community College',
  'Antioch University',
  'Apex Technical School',
  'Appalachian State University',
  'Aquinas College',
  'Arizona Automotive Institute',
  'Arizona State University',
  'Arkansas State University',
  'Arkansas Tech University',
  'Art Institute of Atlanta',
  'Art Institute of Pittsburgh',
  'Ashford University',
  'Assumption College',
  'Aston University',
  'Athens State University',
  'Auburn University',
  'Augsburg College',
  'Augustana College',
  'Austin Peay State University',
  'Averett College',
  'Ayr Tech Scotland',
  'Azusa Pacific University',
  'Babson College',
  'Baker University',
  'Baldwin Wallace College',
  'Ball State University',
  'Baltimore Community College',
  'Bangladesh University of Engineering &amp; Technology',
  "Bard College at Simon's Rock",
  'Barnard College',
  'Barry University',
  'Bates College',
  'Baylor University',
  'Bellevue College',
  'Belmont Abbey College',
  'Belmont Technical College',
  'Benedictine College',
  'Bengal Engineering College',
  'Bentley College',
  'Bergen Community College',
  'Berkeley College',
  'Berkshire Community College',
  'Bessemer State Technical College',
  'Bloomsburg University of Pennsylvania',
  'Bethany College',
  'Bethel College',
  'Bluffton College',
  'Bogazici University',
  'Boise State University',
  'Boston Architectural College',
  'Bombay University - India',
  'Boston College',
  'Boston University',
  'Bowdoin College',
  'Bowie State University',
  'Bowling Green State University',
  'Bradford School',
  'Brandeis University',
  'Bradley University',
  'Brevard Community College',
  'Brewer Christian College &amp; Grad School',
  'Bridgewater College',
  'Brigham Young University',
  'British Columbia Institute of Technology',
  'Brookdale Community College',
  'Brookhaven College',
  'Brooklyn Technical College',
  'Broward Community College',
  'Brown University',
  'Bryant &amp; Stratton Business Institute',
  'Bryant College',
  'Bucharest Institute of Technology',
  'Bucknell University',
  'Bucks County Community College',
  'Burdette College',
  'Burlington County College',
  'Butler County Community College',
  'Butte College',
  'C.W. Post College',
  'Cabrillo College',
  'Cabrini College',
  'Calhoun Community College',
  'California Coast University',
  'California Lutheran University',
  'California State Polytechnic University, Pomona',
  'California State Polytechnic University, San Luis Obispo',
  'California State University, Chico',
  'California State University, Dominguez Hill',
  'California State University, Fresno',
  'California State University, Fullerton',
  'California State University, Hayward',
  'California State University, Long Beach',
  'California State University, Los Angeles',
  'California State University, Northridge',
  'California State University, Sacramento',
  'California State University, San Francisco',
  'California State University, San Marcos',
  'Campbell University',
  'California State University, Stanislaus',
  'California University of Pennsylvania',
  'Cambria County Area Community College',
  'Cambridge College',
  'Camden County College',
  'Cameron University',
  'Can Tho University - Vietnam',
  'Cape Peninsula University of Technology',
  'Capella University',
  'Capital University',
  'College of Saint Rose',
  'Carleton College',
  'Carnegie Mellon University',
  'Carroll College',
  'Carson-Newman College',
  'College of St. Benedict',
  'Carthage College',
  'Case Western Reserve University',
  'Catholic University of America',
  'Academy of Court Reporting',
  'Acharya Nagarjuna University',
  'Ain Shams University',
  'All India Institute of Technical Education, India',
  'Allan Hancock College, Santa Maria, CA',
  'Alvin Community College',
  'American Business Institute',
  'Amersham &amp; Wycombe College',
  'Arapahoe Community College',
  'Argosy University',
  'Associated Electrical Contractors Apprentice Program',
  'Baku State University',
  'Bandung Institute of Technology',
  'Bauder College',
  'Becker College',
  'Board of School Education',
  'Bradford School at Pittsburgh',
  'Bradford University',
  'Bryn Mawr College',
  'Bucharest Construction Institute',
  'Bunker Hill Community College',
  'C.B.P. Government Engineering College',
  'California State University, Maritime Academy',
  'Calvin College',
  'Cape Cod Community College',
  'Carleton University',
  'Cebu Institute of Technology',
  'Cedar Valley College',
  'Cedarville University',
  'Centenary College',
  'Centenary College of New Jersey',
  'Central Connecticut State University',
  'Central Michigan University',
  'Central Missouri State University',
  'Central State University',
  'Central Texas College',
  'Central Virginia Community College',
  'Central Washington University',
  'Centralia College',
  'CEPT University',
  'Champlain College',
  'Chandler School',
  'Chapman University',
  'Charter Oak State College',
  'Chattanooga State Technical Community College',
  'Cheyney University of Pennsylvania',
  'Chicago State University',
  'Chicago Tech',
  'Christian Brothers University',
  'Christopher Newport University',
  'Cincinnati Technical College',
  'Cipriani College of Labour and Co-operative Studies',
  'City &amp; Guilds',
  'City College of San Francisco',
  'Claremont Mckenna College',
  'Clark Atlanta University',
  'Clarkson University',
  'Clayton College and State University',
  'Clemson University',
  'Cleveland Institute of Art',
  'Cleveland State University',
  'Cogswell Polytechnic College',
  'Colby College',
  'Colby Sawyer College',
  'Colgate University',
  'College Misericordia',
  'College of Alameda',
  'College of Applied Science',
  'College of Architecture - India',
  'College of Arts, Science and Technology',
  'College of DuPage',
  'College of Engineering - India',
  'College of Lake County',
  'College of Marin',
  'College of Mount St. Joseph',
  'College of New Jersey',
  'College of Notre Dame, CA',
  'College of Saint Catherine',
  'College of Saint Elizabeth',
  'College of San Mateo',
  'College of St. Catherine',
  'College of St. Frances',
  'College of the Holly Names',
  'College of The Holy Cross',
  'College of The Redwoods',
  'College of William &amp; Mary',
  'Collin County Community College',
  'Colorado College',
  'Colorado School of Mines',
  'Colorado State University',
  'Colorado Techical University Online',
  'Columbia College',
  'Columbia Southern University',
  'Columbia University',
  'Columbus State Community College',
  'Columbus Technical College',
  'Community College Of Alleghany County',
  'Community College of Aurora',
  'Community College of Philadelphia',
  'Community College of Rhode Island',
  'Community College of the Air Force',
  'Concordia University',
  'Connecticut College',
  'Connors State College',
  'Construction Industry Technician',
  'Contra Costa College',
  'Cooper Union',
  'Cork Institute of Technology',
  'Cornell University',
  'Creighton University',
  'Croydon College',
  'Cumberland College',
  'CUNY Baruch College',
  'CUNY Borough of Manhatten Community College',
  'CUNY Bronx Community College',
  'CUNY Brooklyn College',
  'CUNY City College',
  'CUNY College of Staten Island',
  'CUNY College of Technology',
  'CUNY Hunter College',
  'CUNY John Jay College',
  'CUNY Kingsborough Community College',
  'CUNY La Guardia Community College',
  'CUNY Lehman College',
  'CUNY Medgar Evers College',
  'CUNY New York City College of Technology',
  'CUNY New York City Community College',
  'CUNY Queens College',
  'CUNY Queensborough Community College',
  'CUNY York College',
  'Curry College',
  'Cuyahoga Community College',
  'Da Lat University',
  'Dallas Baptist University',
  'Daniel Webster College',
  'Danville University',
  'Dartmouth College',
  'Daughon’s Business College',
  'Davenport University',
  'David Lipscomb University',
  'Davis &amp; Elkins College',
  'Daymar College',
  'Daytona Beach Community College',
  'De Anza College',
  'De La Salle University',
  'De Paul University',
  'Dean College',
  'Dekalb College',
  'Del Mar College',
  'Delaware County Community College',
  'Delaware Technical &amp; Community College',
  'Delaware Valley College',
  'Delta State University',
  'Denison University',
  'DePauw University',
  'Detroit Institute of Arts',
  'Devry Institute of Technology',
  'Diablo Valley College',
  'Dian Institute of Tourisme',
  'Dickinson College',
  'District Council of Carpenters Labor Technical College',
  'Dokuz Eylul University',
  'Dominican University O&amp;M',
  'Dominican University of San Rafael',
  'Donnally College',
  'Dordt College',
  'Dowling College',
  'Drake University',
  'Drexel University',
  'Drury University',
  'Dublin Institute of Technology',
  'Duke University',
  'Dundee University - Scotland',
  'Duquesne University',
  'Dutchess Community College',
  'Dyke College',
  'East Carolina University',
  'East Stroudsburg University',
  'Eastern Connecticut State University',
  'Eastern Illinois University',
  'Eastern Kentucky University',
  'Eastern Michigan University',
  'Eastern Nazarene College',
  'Eastern University',
  'Eastern Washington University',
  'Eastfield College',
  'Ecole Hoteliere de Lausanne',
  'Edexcel - UK',
  'Edinboro University',
  'Edmonds Community College',
  'El Camino College',
  'El Centro Community College',
  'Elmhurst College',
  'Elon University',
  'Embry - Riddle Aeronautical University',
  'Emily Carr Institute',
  'Emory University',
  'Empire State College',
  'Emporia State University',
  'ER Higher Secondary School, Trichy',
  'Erasmus Universiteit Rotterdam',
  'Erie Community College',
  'Essex Community College',
  'Eurasian Humanities Institute',
  'Everglades University',
  'Excelsior College',
  'Faculty of Architecture – University of Belgrade',
  'Faculty of Civil Engineering – University of Belgrade',
  'Faculty of Mechanical Engineering – University of Belgrade',
  'Fairfield University',
  'Fairleigh Dickinson University',
  'Fairmont State University',
  'Far Eastern University',
  'Fashion Institute of Technology',
  'Fayetteville State University',
  'Fellow of the Chartered Institute of Builders',
  'Ferris State University',
  'Ferrum College',
  'Fisher Jr. College',
  'Fitchburg State College',
  'Florida A&amp;M University',
  'Florida Atlantic University',
  'Florida Community College of Jacksonville',
  'Florida Institute of Technology',
  'Florida International University',
  'Florida State University',
  'Fontbonne University',
  'Foothill College',
  'Forbes Trail Technical Institute',
  'Fordham University',
  'Fort Hays State University',
  'Framingham State University',
  'Franklin &amp; Marshall College',
  'Franklin Community College',
  'Franklin Pierce College',
  'Franklin University',
  'Fresno City College',
  'Fullerton College',
  'Fundacion Universidad del Nort',
  'Galway Regional College',
  'Galway-Mayo Institute of Technology',
  'Gannon University',
  'Gaston College',
  'Gateway Community and Technical College',
  'Gateway Community College',
  'Genesee Community College',
  'Geneva College',
  'Geoghegan College',
  'George Mason University',
  'George Washington University',
  'Georgetown University',
  'Georgia Institute of Technology',
  'Georgia Military College',
  'Georgia Southern University',
  'Georgia State University',
  'Georgian Court College',
  'Gettysburg College',
  'GGN Khalsa College',
  'Giani Zail Singh College',
  'Glassboro State College',
  'Glendale Community College',
  'Golden Gate University',
  'Gonzaga University',
  'Gove City College',
  'Governors State Univerisity',
  'Govt Polytechnic Nilokheri',
  'Graceland University',
  'Grambling State University',
  'Grand Canyon University',
  'Grand Rapids Community College',
  'Grand Valley State University',
  'Grantham University',
  'Grays Harbor College',
  'Green River Community College',
  'Grinnell College',
  'Guru Govind Singh Indraprastha University',
  'Gustavus Adolphus College',
  'Ha Noi Department of Construction, Viet Nam',
  'Hamilton College',
  'Hamilton University',
  'Hammersmith College of Technology',
  'Hampton University',
  'Hanoi Construction University',
  'Hanoi University of Architecture',
  'Hanoi University of Civil Engineering',
  'Hanoi University of Fine Arts',
  'Hanoi University of Foreign Study',
  'Hanoi University of Science and Technology',
  'Hanoi University of Technology',
  'Hanover College',
  'Harding University',
  'Harrisburg Area Community College',
  'Hartford University',
  'Hartwick College',
  'Harvard Business School',
  'Harvard University',
  'Hastings College',
  'Hatfield Polytechnic',
  'Havana University',
  'Haverford College',
  'Hawthorne Secondary College',
  'HCM Economic University',
  'HCM Poly - Technical University - Vietnam',
  'HCM Technical University - Vietnam',
  'Heald Institute of Technology',
  'Henderson State University',
  'Henry Ford Community College',
  'Heriot - Watt University',
  'Hickey College',
  'High School of Construction (Section-HVAC), Constanta-Romania',
  'Higher Colleges of Technology',
  'Hillsborough Community College',
  'Hillsdale College',
  'Ho Chi Minh City University of Foreign Languages and Information Technology',
  'Ho Chi Minh Department of Construction, Viet Nam',
  'Hobart and William Smith Colleges',
  'Hochschule Bremen - University of Applied Sciences Bremen',
  'Hocking College',
  'Hofstra University',
  'Hogere Handels School',
  'Hollins University',
  'Holy Angel University',
  'Hope International University',
  'Housatonic Community College',
  'Houston Baptist University',
  'Houston Community College',
  'Howard Community College',
  'Howard University',
  'Hudson Valley Community College',
  'Hue University',
  'Husson College',
  'IBEW NJATC',
  'Illinois Institute of Technology',
  'Illinois State University',
  'Illinois Valley Community College',
  'Illinois Wesleyan University',
  'India Institute of Technology',
  'Indiana State University',
  'Indiana University Bloomington',
  'Indiana University Kelley School of Business',
  'Indiana University Maurer School of Law',
  'Indiana University McKinney School of Law',
  'Indiana University Northwest',
  'Indiana University of Penn',
  'Indiana University - Purdue University',
  'Iona College',
  'Institute of Design &amp; Construction',
  'Indiana Wesleyan University',
  'Institute of Commercial Management',
  'Institute of Construction',
  'Institute of Technology Carlow',
  'Interamerican University of Puerto Rico',
  'International Business College',
  'Inalde Business School',
  'Indian Hills Community College',
  'Indian Institute of Management',
  'Indian School of Business',
  'Indo Global College of Engineering and Technology',
  'Institut National des Sciences Appliquées',
  'Institute of Architecture, Bucharest',
  'Iowa State University',
  'Iran University of Science and Technology',
  'Istanbul Academy of Fine Arts',
  'Istanbul Technical University',
  'Ithaca College',
  'ITI Technical College',
  'ITT Technical Institute',
  'Polytechnic College',
  'Polytechnic Institute, Minsk, Belarus',
  'Polytechnic Sultan Salahhuddin Abdul Aziz Shah, Shah Alam',
  'Polytechnic University',
  'Polytechnic University of El Salvador',
  'Polytechnic University Of Puerto Rico',
  'Polytechnic University of Ukraine',
  'Pontificia Universidad Catolica del Peru',
  'Portland Community College',
  'Portland State University',
  'Portsmouth University',
  'Poznan University of Economics',
  'Prairie View A&amp;M University',
  'Pratt Institute',
  "Prince George's Community College",
  'Princeton Review',
  'Princeton University',
  'Providence College',
  'Purdue University',
  'Queens Institute',
  'Queens University Belfast',
  'Queensland University of Technology',
  'Quinebaug Valley Community College',
  'Quinnipiac University',
  'Radford University',
  'Ramapo College of New Jersey',
  'Randolph-Macon College',
  'Regional Engg College - India',
  'Regis College',
  'Rensselaer Polytechnic Institute',
  'Rheinisch-Westfalische Technische Hochschule ',
  'Rhode Island School of Design',
  'Rice University',
  'Richard Stockton College of New Jersey',
  'Richland College',
  'Rider University',
  'Rio Salado Community College',
  'Riverside City College',
  'Robert Morris College - Illinois',
  'Robert Morris University - PA',
  'Rochester Institute of Technology',
  'Rockhurst University',
  'Roger Williams University',
  'Roosevelt University',
  'Rose-Hullman Institute of Technology',
  'Roxbury Community College',
  'Ruhr-Universitat Bochum',
  'Russell Sage College',
  'Rutgers The State University of New Jersey',
  'Rutgers University, College of Engineering',
  'Rutgers University, Graduate School of Management',
  'Ryde College of Technical &amp; Further Education',
  'Ryerson University',
  'Sacramento City College',
  'Sacred Heart University',
  'Saddleback College',
  'Sage College of Albany',
  'Saginaw Valley State University',
  'Saint Bonaventure University',
  'Saint Francis College',
  "Saint Joseph's University",
  'Saint Leo College',
  "Saint Michael's College",
  'Saint Xavier Univesity',
  'Salem State College',
  'Sam Houston State University',
  'Samford University',
  'San Antonio College',
  'San Bernardino Valley College',
  'San Diego State University',
  'San Francisco Institute of Architecture',
  'San Francisco State University',
  'San Jacinto College District',
  'San Joaquin Delta College',
  'San Jose City College',
  'San Jose State University',
  'Sanford-Brown College',
  'Santa Clara University',
  'Santa Fe Community College',
  'Santa Monica College',
  'Santa Rosa Junior College',
  'Sardar Vallabhbhai Patel University - India',
  'Savannah College of Arts &amp; Design',
  'Schoolcraft College',
  'Seattle Central Community College',
  'Seattle University',
  'Selcuk University',
  'Seminole Community College',
  'Seshasayee Institute of Technology, Trichirappalli',
  'Seton Hall University',
  'Shanghai Jiao Tong University',
  'Shasta College',
  'Sheffield College',
  'Shippensburg University',
  'Shiraz University',
  'Siena College',
  'Sierra College',
  'Simmons College',
  'Simon Fraser University',
  'Simpson College',
  'Sinclair Community College',
  'Singapore Polytechnic',
  'Skidmore College',
  'Slippery Rock University',
  'Smart Horizons',
  'Smith College',
  'Social Science and Humanities University',
  'Solano Community College',
  'Sonoma State University',
  'South Bank Polytechnic',
  'South Dakota School of Mines &amp; Technology',
  'South Piedmont College',
  'South Suburban College',
  'South University',
  'Southeast Missouri State University',
  'South Dakota State University',
  'Southern California Institute of Architecture',
  'Southern College of Technology',
  'Southern Connecticut State University',
  'Southern Illinois University',
  'Southern Maine Technical College',
  'Southern Methodist University',
  'Southern New Hampshire University',
  'Southern Ohio College',
  'Southern Oregon University',
  'Southern Polytechnic State University',
  'Southern Union State Community College',
  'Southern University and A&amp;M College',
  'Southern Utah University',
  'Southern Wesleyan University',
  'Southwestern College',
  'Spartanburg Community College',
  'Spelman College',
  'Spokane Community College',
  'Spring Garden College',
  'Spring Hill College',
  'Springfield College',
  'St. Ambrose University',
  "St. Augustine's College",
  "St. Edward's University",
  'St. John Fisher College',
  'St. Johns College',
  "St. John's University",
  "St. Joseph's College",
  'St. Louis Community College',
  'St. Louis Community College at Meramec',
  'St. Louis University',
  "St. Loye's College - Exeter, Devon",
  "St. Mary's College of California",
  "St. Mary's College of Maryland",
  'St. Olaf College',
  'St. Peters College',
  'St. Petersburg College',
  'St. Thomas Aquinas College',
  'Stanford University',
  'State College with the Ministry of Statistics of the Russian Federation',
  'State University - Higher School of Economics',
  'State University of New York',
  'Stautzenberger Business College',
  'Stephen F. Austin State University',
  'Stevens Institute of Technology',
  'Stonehill College',
  'Stony Brook University',
  'Strayer University',
  'Suffolk Community College',
  'Suffolk University',
  'Sullivan University',
  'Sultan Salhuddin Abdul Aziz Shah Polytechnic',
  'SUNY Albany',
  'SUNY Alfred College of Technology',
  'SUNY Binghamton',
  'SUNY Broome Community College',
  'SUNY Canton College of Technology',
  'SUNY College of Agricultre and Technology at Morrisville',
  'SUNY College of Environmental Science &amp; Forestry',
  'SUNY College of Technology at Farmingdale',
  'SUNY Cortland New York',
  'SUNY Delhi College of Technology',
  'SUNY Empire State College',
  'SUNY Institute of Technology',
  'SUNY Maritime College of Technology',
  'SUNY Plattsburgh',
  'SUNY Stony Brook',
  'SUNY University at Brockport',
  'SUNY University at Buffalo',
  'SUNY University at Fredonia',
  'SUNY University at New Paltz',
  'SUNY University at Old Westbury',
  'SUNY University at Oneonta',
  'SUNY University at Oswego',
  'SUNY University at Potsdam',
  'Swarthmore College',
  'Sydney Industry University',
  'Syracuse University',
  'Tacoma Community College',
  'Tarleton State University',
  'Tarrant County College',
  'University of Pittsburgh at Johnstown',
  'University of Pittsburgh at Titusville',
  'University of Plymouth - United Kingdom',
  'University of Portland',
  'University of Puerto Rico',
  'University of Puerto Rico at Mayaguez',
  'University of Puget Sound',
  'University of Reading - UK',
  'University of Redlands',
  'University of Rhode Island',
  'University of Richmond',
  'University of Rochester',
  'University of Roorkee - India',
  'University of Sacred Heart',
  'University of San Francisco',
  'University of Santo Thomas',
  'University of Scranton',
  'University of South Carolina',
  'University of South Dakota',
  'University of South Florida',
  'University of Southampton',
  'University of Southern California',
  'University of Southern Indiana',
  'University of Southern Mississippi',
  'University of St.Thomas',
  'University of Surrey',
  'University of Tampa',
  'University of Technology Sydney',
  'University of Technology, Iraq',
  'University of Tehran',
  'University of Tennessee',
  'University of Texas at Arlington',
  'University of Texas at Austin',
  'University of Texas at Dallas',
  'University of Texas at El Paso',
  'University of Texas at SanAntonio',
  'University of Texas at Tyler',
  'University of the District of Columbia',
  'University of the East-Manila',
  'University of the Pacific',
  'University of the Phillipines',
  'University of the Southern Caribbean',
  'University of the West Indies',
  'University of Toledo',
  'University of Toronto',
  'University of Tulsa',
  'University of Ulster',
  'University of Utah',
  'University of Vermont',
  'University of Virginia',
  'University of Washington',
  'University of Waterloo - Canada',
  'University of West Florida',
  'University of Western Ontario',
  'University of Windsor',
  'University of Winnipeg',
  'University of Wisconsin - Madison',
  'University of Wisconsin - Milwaukee',
  'University of Wisconsin - Platteville',
  'University of Wisconsin - Stevens Point',
  'University of Wisconsin - Stout',
  'University of Wollongong Australia',
  'University of Wyoming',
  'University Putra Malaysia',
  'University Technical Malaysia Melaka',
  'University Technology Mara',
  'Upsala College',
  'US Air Force Academy',
  'US Army War College',
  'US Department Defense Mapping School',
  'US Merchant Marine Academy',
  'US Military Academy-West Point',
  'US Naval Academy',
  'US Naval Institute',
  'US Naval Technical School',
  'Utah State University',
  'Utah Valley State College',
  'Utica College of Syracuse University',
  'Valencia Community College',
  'Valparaiso University',
  'Vanderbilt University',
  'Vassar College',
  'Vauxhall College of Technology',
  'Ventura College',
  'Vermont Tecnical College',
  'Vietnam National University',
  'Villa Maria College',
  'Villanova University',
  'Virginia Commonwealth University',
  'Virginia Military Institute',
  'Virginia Polytechnic Institute/virginia Tech',
  'Virginia Wesleyan College',
  'Virginia Western Community College',
  'Volunteer State Community College',
  'Wagner College',
  'Wake Forest University',
  'Walsh College',
  'Washington and Jefferson College',
  'Washington and Lee University',
  'Washington College',
  'Washington State University',
  'Washington University in St. Louis',
  'Watchtower Bible &amp; Tract Society',
  'Waterford Institute of Technology',
  'Waterford Regional Technical College',
  'Watford College of Technology',
  'Wayne County Community College',
  'Wayne State University',
  'Weber State University',
  'Webster University',
  'Wellesley College',
  'Wentworth Institute of Technology',
  'Wesleyan University',
  'West Chester Community College',
  'West Chester University',
  'West Texas A&amp;M University',
  'West Valley College',
  'West Virginia Institute of Technology',
  'West Virginia University',
  'West Virginia Wesleyan College',
  'Western Carolina University',
  'Western Connecticut State University',
  'Western Illinois University',
  'Western Iowa Tech',
  'Western Kentucky University',
  'Western Michigan University',
  'Western New England College',
  'Western State College of Colorado',
  'Western Washington University',
  'Westfield State College',
  'Westland College - Fresno',
  'Westminister College',
  'Westmoreland County Community College',
  'Westwood College',
  'Wichita State University',
  'Widener University',
  'Wiley College',
  'Wilkes University',
  'Willamette University',
  'William Paterson College',
  'Wilmington College',
  'Winston-Salem State University',
  'Winthrop University',
  'Wittenberg University',
  'Woodbury University - California',
  'Worcester Polytechnic Institute',
  'Worcester State College',
  'Wright State University',
  'Xavier University',
  'Yale University',
  'Yeshiva University',
  'Yildiz Technical University',
  'Yonsei University',
  'York University',
  'York University Schulich School of Business',
  'Youngstown State University',
  'Yuba College',
  'Mohawk College',
  'Monmouth University',
  'Monroe County Community College',
  'Montana College Of Mineral Science &amp;Technology',
  'Montana State University',
  'Montclair State University',
  'Monterey College Of Law',
  'Montgomery College',
  'Morehead State University',
  'Morehouse College',
  'Morgan State University',
  'Moscow State Construction University',
  'Moscow State Institute of Radio-Engineering Electronics and Automation',
  'Moscow State University of Electronic Technology',
  'Mount Holyoke College',
  'Mount Hood Community College',
  "Mount Saint Mary's College",
  'Mount St. Vincent University',
  'Mount Vernon Nazarene University',
  'Mount Wachuset Community College',
  'Muhammadiyah University of Surakarta',
  'Muhlenberg College',
  'Multimedia University',
  'Mumbai University, India',
  'Murray State University',
  'Myers University',
  'Nal Autonoma De Mexico',
  'Nalanda Institute of Technology',
  'Napa Valley Cooking School',
  'Nashville State Community College',
  'Nashville State Technical Institute',
  'Nassau Community College',
  'National Autonomous University of Mexico',
  'National Inst of Elect and Info Tech',
  'National Institute of Construction Management &amp; Research, India',
  'National Institute of Technology, Calicut, India',
  'National Taiwan University',
  'National University',
  'National University of Civil Engineering',
  'National University of Singapore',
  'National-Louis University',
  'Naugatuck Valley Community College',
  'Naval Institute Nha Trang',
  'Navarro College',
  'New England College',
  'Northwestern University',
  'Northwood University',
  'Norwich University',
  'Notre Dame College',
  'Nova Southeastern University',
  'Nyack College',
  'Oakland Community College',
  'Oakland University',
  'Oberlin College',
  'Ocean County College',
  'Ohio Business College',
  'Ohio Dominican University',
  'Ohio Northern University',
  'Ohio State University',
  'Ohio University',
  'Ohio Wesleyan',
  'Oklahoma State University',
  'Oklahoma Wesleyan University',
  'Old Dominion University',
  'Open University',
  'Oral Roberts University',
  'Orange Coast College',
  'Orange County Community College',
  'Oregon State University',
  'Orta Dogu Technical University',
  'Ottawa University',
  'Otterbein College',
  'Our Lady of the Lake',
  'Owens Community College',
  'Pace University',
  'Pacific Lutheran University',
  'Pacific Oaks College',
  'Paisley College of Technology',
  'Palm Beach Community College',
  'Palomar College',
  'Parahyangan Catholic University',
  'Park University',
  'Parsons School of Design',
  'Pasadena City College',
  "Paul Smith's College",
  'Peace College',
  'Peirce College',
  'Pennsylania State University at  Harrisburg',
  'Pennsylvania College of Technology',
  'Pennsylvania Institute of Technology',
  'Pennsylvania State University',
  'Pensacola Junior College',
  'Penta Technical College',
  "Peoples' Friendship University of Russia",
  'Pepperdine University',
  'Perbanas Institute',
  'Permanent Way of Railway Engineering',
  'Philadelphia College of Textiles &amp; Science',
  'Phillips Junior College',
  'Phoenix Institute of Technology',
  'Piedmont College',
  'Pikes Peak Community College',
  'Pima Community College',
  'Pittsburgh State Univiversity - Kansas',
  'Plymouth State College',
  'Point Park College',
  'Taylor Business Institute',
  'Taylor University',
  'Technical Career Institutes',
  'Technical School of Social Trade',
  'Technical University of Cluj-Napoca, Romania',
  'Technical University of Madrid',
  'Temple University',
  'Ten of November Institute of Technology',
  'Tennessee State University',
  'Tennessee Tech University',
  'Texas A &amp; I University',
  'Texas A&amp;M University',
  'Texas A&amp;M University-Commerce',
  'Texas Christian University',
  'Texas State University',
  "Texas Woman's University",
  'The Boston Conservatory',
  'The Chicago School of Professional Psychology',
  'The Citadel',
  'The John Marshall Law School',
  'The Navy Institute, Nha Trang, Viet Nam',
  'The New School',
  'The Union Institute',
  'Thiagarajar College of Engineering',
  'Thiel College',
  'Northwestern State University',
  'Northwestern Connecticut Community College',
  'Northwestern College',
  'Northwest Technical College',
  'Northland College',
  'Northern Virginia Community College',
  'Northern University of Malaysia',
  'Northern Michigan University',
  'Northern Kentucky University',
  'Northern Illinois University',
  'Northeastern University',
  'Northeastern State University',
  'Northeast. Louisana University',
  'Northeast Alabama Community College',
  'Northampton Community College',
  'North Texas Carpenters &amp; Millwrights Apprenticeship School',
  'North Shore Community College',
  'North Seattle Community College',
  'North Park University',
  'North Lake College',
  'North Dakota State University',
  'North Central University',
  'North Central College',
  'North Carolina State University',
  'North Carolina Central University',
  'North Carolina A &amp; T State University',
  'Norfolk State University',
  'Nong Lam University',
  'Niagara University',
  'Nha Trang University',
  'Newark College Of Engineering',
  'New York University School of Law',
  'New York University',
  'New York Institute of Technology',
  'New York Career Institute',
  'New School of Archchitecture and Design',
  'New Mexico State University',
  'New Mexico Junior College',
  'New Mexico Institute of Mining and Technology',
  'New Jersey Institute of Technology',
  'New England Technical Institute',
  'New England Institute of Technology',
  'New England Conservatory of Music',
  'Thomas Edison State College',
  'Thomas More College',
  'Three Rivers Community College',
  'Thu Duc University of Transportation',
  'Tidewater Community College',
  'Tompkins-Skidmore Community College',
  'Touro College - Graduate School',
  'Towson State University',
  'Tralee Regional Technical College',
  'Trenton State College',
  'Trichy Institute of Management',
  'Trine University',
  'Trinidad State Junior College',
  'Trinity College',
  'Trinity College Dublin',
  'Trinity University',
  'Trinity Western University',
  'Tri-State University',
  'Triton College',
  'Trondheim Technological College',
  'Troy State University',
  'Truman State University',
  'Tsinghua University',
  'TU Dortmund University',
  'Tuck School of Business Administration at Dart',
  'Tufts University',
  'Tulane University',
  'Tuskegee University',
  'Tver State University',
  'Twintech Bangi',
  'Twintech International University College of Technology',
  'U.S. Army',
  'UCAB - Facultad de Ingenieria',
  'Union College',
  'United Brotherhood of Carpenters-Joiners of America',
  'United States Coast Guard Academy',
  'Univ of Cincinnati',
  'Universidad Autonoma de Guadalajara',
  'Universidad Autonoma de Nuevo Leon',
  'Universidad Autónoma Metropolitana',
  'Universidad Catolica Andres Bello',
  'Universidad Catolica de Colombia',
  'Universidad Catolica de La Plata',
  'Universidad Central de Venezuela',
  'Universidad Central del Ecuador',
  'Universidad de Cataluña',
  'Universidad de Chile',
  'Universidad de Guadalajara - Mexico',
  'Universidad de Guanajuato',
  'Universidad de Monterrey',
  'Universidad de Palermo',
  'Universidad del Norte',
  'Universidad del Salvador - Argentina',
  'Universidad EAFIT - Columbia',
  'Universidad Iberoamericana',
  'Universidad Metropolitana',
  'Universidad Militar Nueva Granada',
  'Universidad Nacional de Ingenieria - Peru',
  'Universidad Santa Maria La Antigua',
  'Universidad Simon Bolivar',
  'Universitat of Leipzig - Germany',
  'Université Catholique de Louvain',
  'Universiti Teknologi Malaysia',
  'Universiti Utara Malaysia',
  'University College - Dublin, Ireland',
  'University Malaysia Terengganu',
  'University of  North Carolina at Wilmington',
  'University of Akron',
  'University of Alabama',
  'University of Alberta',
  'University of Aleppo',
  'University of Allahabad',
  'University of Applied Sciences',
  'University of Arizona',
  'University of Arkansas',
  'University of Arkansas at Fayetteville',
  'University of Atmajaya',
  'University of Baghdad',
  'University of Baltimore',
  'University of Barcelona',
  'University of Barode',
  'University of Benin',
  'University of Berkley - Michigan',
  'University of Bombay',
  'University of Bridgeport',
  'University of Bristol',
  'University of British Columbia',
  'University of Buffalo',
  'University of Calcutta',
  'University of California,  Los Angeles',
  'University of California, Berkeley',
  'University of California, Davis',
  'University of California, Irvine',
  'University of California, Riverside',
  'University of California, San Diego',
  'University of California, San Francisco',
  'University of California, Santa Barbara',
  'University of California, Santa Clara',
  'University of California, Santa Cruz',
  'University of Cambridge',
  'University of Canterbury',
  'University of Cape Town',
  'University of Central Florida',
  'University of Central Lancashire',
  'University of Central Missouri',
  'University of Chicago',
  'University of Cincinnati',
  'University of Civil Engineering',
  'University of Colombia',
  'University of Colorado',
  'University of Colorado at Boulder',
  'University of Connecticut',
  'University of Dallas',
  'University of Dayton',
  'University of Delaware',
  'University of Denver',
  'University of Detroit',
  'University of Engineering and Technology - Pakistan',
  'University of Engineering and Technology Lahore',
  'University of Evansville',
  'University of Findlay',
  'University of Florida',
  'University of Georgia',
  'University of Glasgow',
  'University of Greenwich',
  'University of Greenwich - United Kingdom',
  'University of Guam',
  'University of Guelph',
  'University of Hartford',
  'University of Houston',
  'University of Idaho',
  'University of Illinois at Chicago',
  'University of Illinois at Urbana-Champaign',
  'University of Indonesia',
  'University of Iowa',
  'University of Iraq',
  'University of Kansas',
  'University of Karala',
  'University of Karlsruhe - Germany',
  'University of Kentucky',
  'University of Khartoum',
  'University of Lagos - Nigeria',
  'University of Leicester',
  'University of Liege',
  'University of Limerick',
  'University of London',
  'University of Los Andes',
  'University of Louisville',
  'University of Luzon',
  'University of Madras',
  'University of Madras - India',
  'University of Maine',
  'University of Malta',
  'University of Manitoba',
  'University of Mary Washington',
  'University of Maryland',
  'University of Massachusetts',
  'University of Massachusetts Amherst',
  'University of Massachusetts Dartmouth',
  'University of Massachusetts Lowell',
  'University of Massachusetts, Boston',
  'University of Memphis',
  'University of Miami',
  'University of Michigan',
  'University of Minnesota',
  'University of Mississippi',
  'University of Missouri - Columbia',
  'University of Montana',
  'University of Nebraska',
  'University of Nevada Reno',
  'University of Nevada, Las Vegas',
  'University of New Hampshire',
  'University of New Haven',
  'University of New Mexico',
  'University of New Orleans',
  'University of North Alabama',
  'University of North Carolina',
  'University of North Carolina at Charlotte',
  'University of North Dakota',
  'University of North Florida',
  'University of North Texas',
  'University of Northern Colorado',
  'University of Northern Iowa',
  'University of Notre Dame',
  'J. Sargeant Reynolds Community College',
  'Jalpaiguri Government Engineering College',
  'James Madison University',
  'Jamia Millia Islamia',
  'Janardan Rai Nagar Rajasthan Vidyapeeth',
  'Jefferson State Community College',
  'Jersey City State College',
  'John Brown University',
  'John Carroll University',
  'John Moores University',
  'Johns Hopkins University',
  'Johnson &amp; Wales University',
  'Joliet Junior College',
  'Judson College',
  'Juniata College',
  'Kabul University',
  'Kansas State University',
  'Kaplan University',
  'Karachi University',
  'Kaskaskia College',
  'Katharine Gibbs School',
  'Kean College of New Jersey',
  'Keene State College',
  'Keller Graduate School of Management - DeVry University',
  'Kennesaw State University',
  'Kensington University',
  'Kent State University',
  'Kenyon College',
  'Knox College',
  'Kutztown University of Pennsylvania',
  'University of Oklahoma',
  'University of Oregon',
  'University of Ottowa - Canada',
  'University of Oxford',
  'University of Pennsylvania',
  'University of Philippines',
  'University of Phoenix',
  'University of Phoenix - South Florida',
  'L. N. Gumilyov Eurasian National University',
  'La Salle University',
  'University of Pittsburgh',
  'La Verne University',
  'Lafayette College',
  'University of Pittsburgh at Greensburg',
  'Lake Forrest College',
  'Lake Superior State University',
  'Lakeland College',
  'Lamar Junior College',
  'Lamar University',
  'Lamson Business College',
  'Lane Community College',
  'Laney Junior College',
  'Lansing Community College',
  'Las Positas College',
  'Lasell College',
  'Lassen Community College',
  'Lawrence Technological University',
  'Lawrence University',
  'Le Moyne College',
  'Lebanon Valley',
  'Lee College',
  'Lehigh University',
  'Lehman College',
  'LeTourneau University',
  'Lewis - Clark State College',
  'Liberty University',
  'Lincoln Land Community College',
  'Lindenwood University',
  'Linfield College',
  'Lock Haven University of PA',
  'London South Bank University',
  'Long Island University',
  'Long Island University -  C.W.Post',
  'Longview Junior College',
  'Lorain Community College',
  'Loras College',
  'Los Angeles Mission College',
  'Los Angeles Valley College',
  'Louisiana State University',
  'Louisiana Tech University',
  'Lowell Technological Institute',
  'Loyola College',
  'Loyola Marymount University',
  'Loyola University, Chicago',
  'Loyola University, New Orleans',
  'Lycoming College',
  'Lynchburg College',
  'Macalester College',
  'Macomb Community College',
  'Macquarie University',
  'Madhurai Kamraj University',
  'Madurai Kamaraj University, Tamilnadu, India',
  'Maharaja Sayajirao University of Baroda - India',
  'Maharashtra Institute of Technology',
  'Maharashtra State Board of Technical Education',
  'Maharshtra State - India',
  'Mahoning County Joint Vocational School',
  'Malaysia France Institute',
  'Manatee Community College',
  'Manchester Community College',
  'Manhattan College',
  'Manhattanville College',
  'Manipal Institute of Technology',
  'Mansfield Business School',
  'Mapua Institute of Technology',
  'Maranatha Baptist Bible College',
  'Maria College',
  'Marist College',
  'Marlboro College',
  'Marquette University',
  'Marshall University',
  'Marshalltown Community College',
  'Marylhurst University',
  'Marymount College',
  'Marymount University',
  'Maryville College',
  'Massachusetts College Of Liberal Arts',
  'Massachusetts Institute of Technology',
  'Massachusetts Maritime Academy',
  'Massachusetts School of Law',
  'Mayne County College',
  'McGill University',
  'McMaster University',
  'Menlo College',
  'Mercer Community College',
  'Mercer University',
  'Mercy College',
  'Meredith College',
  'Merrimack College',
  'Merritt College',
  'Mesa Community College',
  'Methodist University',
  'Metropolitan Community College',
  'Miami University - Ohio',
  'Miami-Dade Community College',
  'Michigan State University',
  'Michigan Technological University',
  'Middle East Technical University',
  'Middle Tennessee State University',
  'Middlesex County College',
  'Middlesex University, London',
  'Midland Technical',
  'Midwestern State University',
  'Military College of Engineering',
  'Millersville University Of Pennsylvania',
  'Millisaps College',
  'Milwaukee School Of Engineering',
  'Mimar Sinan University',
  'Minnesota State University at  Mankato',
  'Minsk State Linguistic University',
  'Mission College',
  'Mississippi College',
  'Mississippi Gulf Coast Community College',
  'Mississippi State University',
  'Missouri State University',
  'Missouri University of Science &amp; Technology',
  'Missouri Valley College',
  'Missouri Western State College',
  'City University of New York',
  "Draughon's Business College",
  'Rowan University',
  'K.G. Engineering Institute Bishnupur',
  'St. Francis College',
  'SUNY Maritime College',
  'University of California, Los Angeles',
  'University of Nis',
  'Adams State University',
  'Adrian College',
  'Afghan Institute of Technology',
  'Afundacion Business School',
  'Alagappa University',
  'Alberta College of Art and Design',
  'Aligarh Muslim University',
  'American Institute of Banking',
  'Amity University',
  'Anderson University',
  'APPEJAY Institute of Technology',
  'Arcadia University',
  'Art Institute of York - Pennsylvania',
  'Asian Institute of Management &amp; Technology',
  'Ateneo de Davao University',
  'Atlantic University',
  'Austin College',
  'Badruka College',
  'Bangalore University',
  'Barking College of Technology',
  'Beijing Institute of Fashion Technology',
  'Belarusian National Technical University',
  'Bellingham Technical College',
  'Belmont University',
  'Benjamin Franklin Institute of Technology',
  'Bethel University',
  'Bhagalpur College of Engineering',
  'Bharat Sevak Samaj',
  'Bharati Vidyapeeth University',
  'Bhilai Institute of Technology - Raipur',
  'Bihar Intermediate Education Council Patna',
  'Bihar School Examination Board',
  'Birla Vishwakarma Mahavidyalaya',
  'Birsa Technical Institute',
  'Bishop’s University',
  'Blake Business School',
  'Bloomfield College',
  'Board of Cooperative Educational Services, Nassau',
  'Board of Technical Education, Lucknow',
  'Board of Technical Education, Maharashtra',
  'Board of Technical Education, New Delhi',
  'Board of Technical Education, Uttar Pradesh',
  'Borough of Manhattan Community College',
  'Briar Cliff University',
  'Brigham Young University - Idaho',
  'Brooklyn College',
  'Budapest University of Technology and Economics',
  'C S Monroe Technology Center',
  'California College of the Arts',
  'Camosun College - Interurban Campus',
  'Canada College',
  'Cape Fear Community College',
  'Cardinal Stritch University',
  'Carlow University',
  'Cayuga Community College',
  'Center for Creative Leadership',
  'Central Alabama Community College',
  'Central Arizona College',
  'Central Board of Secondary Education - New Delhi',
  'Central County Occupational Center',
  'Central Piedmont Community College',
  'Cerritos College',
  'Chabot College',
  'Chatrapati Sahuji Maharaj University',
  'Chemeketa Community College',
  'Cleveland Community College',
  'CMJ University',
  'Coastal Carolina University',
  'Coastline Community College',
  'College of Charleston',
  'College of Creative Studies',
  'College of Foreign Economic Relations',
  'College of Southern Nevada',
  'College of Technologies and Economics in Trade',
  'College of Wooster',
  'Columbus Business University',
  'Community College of Baltimore County - Catonsville',
  'County College of Morris',
  'Cypress College',
  'Darbhanga House',
  'Dav Inter College',
  'Deakin University',
  'Dehli University',
  'Delft University of Technology',
  'Delgado Community College',
  'Delhi Technological University',
  'DeVry University',
  'Dominican College of Blauvelt',
  'Dominican University of California',
  'Dr. Babasaheb Ambedkar Marathwada University',
  "Ealing, Hammersmith &amp; West London's College",
  'Eastern Florida State College',
  'Eastern Mediterranean University',
  'Ecole Speciale des Travaux Publics',
  'Ege University',
  'EIILM University',
  'Escuela Bancaria Y Comercial',
  'Escuela Técnica Superior de Arquitectura de Madrid',
  'Essex County Vocational Educational Center',
  'Executive Secretarial School',
  'SUNY University at Geneseo',
  'SUNY University at Cobleskill',
  'Sultan Azlan Shah Polytechnic',
  'Stetson University',
  'State Board of Technical Education and Training',
  'Stark State College',
  'St. Thomas University',
  'St. Phillips College',
  'St. Lawrence University',
  'Symbiosis Centre for Distance Learning',
  'St. Charles Community College',
  'Sri Venkateswara University',
  'Szent István University',
  'Taft Law School',
  'Fanshawe College',
  'Tashkent Polytechnic Institute',
  'Farmigdale State College',
  'Technical School of Electronics in Rzeszow, Poland',
  'Fayetteville Technical Community College',
  'Technical University of Dresden, Germany',
  'Federal Institute of Technology',
  'Technical University of Munich',
  'FH Aachen Aachen University of Applied Sciences',
  'Technikon Witwatersrand',
  'Florida Bible College',
  'Technische Fashschule Biel',
  'Fort Lewis College',
  'Frostburg State University',
  'Tecnológico de Estudios Superiores de Cuautitlán Izcalli',
  'Full Sail University',
  'Tecnológico de Monterrey',
  'Furman University',
  'Texas A&amp;M Engineering Extension Service',
  'Texas A&amp;M University, San Antonio',
  'Texas State Technical College',
  'Gavilan College',
  'Texas Tech University',
  'Gazi University',
  'Texas Technical University',
  'George Brown College',
  'The Applied Sciences University – Jordan',
  'GlobalNxt University',
  'The Christ College of Nursing and Health Sciences',
  'The College of Estate Management',
  'The Institution of Engineers, India',
  'The Institution of Surveyors',
  'Golden West College',
  'The University of Melbourne',
  'Gordon College',
  'Thompson Rivers University',
  'Tianjin Chengjian University',
  'Government College of Technology',
  'Trenholm State Technical College',
  'Government Engineering College',
  'Triangle Technical Institute',
  'Government Polytechnic Sakoli',
  'Trident University International',
  'Grand View University',
  'Trinity Valley Community College',
  'Gujarat National Law University',
  'Tunku Abdul Rahman University College',
  'Gulbarga University',
  'Tyler Junior College',
  'Guru Jambheshwar University-Science &amp; Technology',
  'UC Berkeley Extension',
  'UCSI University, Kuala Lumpur',
  'Ungku Omar Polytechnic',
  'Hamburg University of Technology',
  'Universal Technical Institute',
  'Universidad Catolica de Santiago de Guayaquil',
  'Universidad Catolica Santa Maria La Antigua',
  'Harcourt Butler Technical University',
  'Universidad del Bio Bio',
  'Universidad Mayor de San Andres , La Paz Bolivia',
  'Hardin-Simmons University',
  'Harper College',
  'Universidad Nacional Autonoma de Mexico',
  'Hautes Etudes d’Ingenieur',
  'Universidad Politecnica de Madrid',
  'HCM University of Social Science &amp; Humanity',
  'Universidad Tecnologica de Mexico',
  'Hiram College',
  'Universidade Federal do Rio de Janeiro',
  'Ho Chi Minh City University of Technology',
  'Ho Chi Minh University of Foreign Languages and Information Technology',
  'Hochshule fur Gestaltung und Kunst Basel',
  'Holy Apostles College and Seminary',
  'Holy Family University',
  'Hult International Business School',
  'Humber College',
  'ICMAS Chennai',
  'Universita degli studi di Roma La Sapienza',
  'Universita La Sapienza Roma',
  'Universitas Andalas',
  'Universite Catholique de Louvain',
  'Universiti Pertanian Malaysia',
  'Universiti Sains, Malaysia',
  'University College Cork, Ireland',
  'University College, London',
  'University of Adelaide',
  'University of Aegean',
  'University of Alabama at Birmingham',
  'University of Alabama in Huntsville',
  'University of Alaska Fairbanks',
  'University of Bath – UK',
  'University of Belgrade',
  'University of Calgary',
  'University of Calicut, India',
  'University of Dundee, UK',
  'University of East London',
  'University of Engineering and Technology, Lahore',
  'University of Jordan',
  'University of Latvia',
  'University of Lucknow, India',
  'University of Malaya',
  'University of Management and Technology',
  'University of Manchester Institute of Science and Technology',
  'University of MARA Technology, Malaysia',
  'University of Mary Hardin-Baylor',
  'University of Maryland, Baltimore County',
  'Imperial College London',
  'University of Memphis Lambuth',
  'Imperial Institute Of Management Science &amp; Research',
  'University of Michigan, Dearborn',
  'Indian Institute of Fire Engineering',
  'University of Missouri - Kansas City',
  'Institute of Administrative Studies',
  'University of Munich',
  'Institute of Civil Engineers, India',
  'University of Mysore',
  'Institute Teknologi Pertama, Malaysia',
  'University of North Carolina at Greensboro',
  'Instituto Mexicano de Contadores Publicos',
  'University of North Carolina at Pembroke',
  'Instituto Normal Para Varones de Occidente',
  'University of North Carolina at Wilmington',
  'Instituto Tecnologico Autonomo de Mexico',
  'University of Nottingham',
  'Instituto Tecnologico de Santo Domingo',
  'University of Padua',
  'Instituto Tecnológico de Tlalnepantla',
  'University of Port Harcourt - Nigeria',
  'International Academy of Design and Technology',
  'University of Pune',
  'Ipade Business School',
  'University of Sarajevo',
  'ISHRAE Education &amp; Research Foundation, India',
  'University of South Australia',
  'Islamic Azad University, Central Tehran Branch',
  'University of Strathclyde',
  'Jacksonville State University',
  'University of Sydney, Australia',
  'University of Technology, Jamaica',
  'University of Texas of the Permian Basin',
  'Jacksonville University',
  'University of the Highlands and Islands',
  'Jadavpur University',
  'University of Wales',
  'Jamshedpur Technical Centre',
  'University of Wolverhampton',
  'Jawaharlal Nehru Technological University',
  'University Tenaga National',
  'JDC Bytco Institute of Management Studies and Research',
  'US Army',
  'US Marine Corps',
  'Utah Valley University',
  'Utkal University',
  'Uttar Pradesh Board of Technical Education',
  'Vaish Technical Institute',
  'Valley Forge Military Academy and College',
  'Vanguard University',
  'Vaughn College of Aeronautics and Technology',
  'Veer Narmad South Gujarat University',
  'Kansas City Kansas Community College',
  'Victoria College',
  'Vietnam Naval Academy',
  'Karnataka State Open University',
  'Vilnius University',
  'Karunya University',
  'Vincennes University',
  'Keiser University',
  'Visvesvaraya National Institute of Technology, Nagpur',
  'Kingston University',
  'Walden University',
  'Kirkwood Community College',
  'Wallace State Community College',
  'Kocaeli University',
  'Warner University',
  'Kokshetau State University, Kazakhstan',
  'Warren National University',
  'Korean Advanced Institute of Science and Technology',
  'Warren Wilson College',
  'KTH Royal Institute of Technology',
  'Wawasan Open University',
  'Wayne State College',
  'Kumaun University',
  'Western Governors University',
  'Kwantlen Polytechnic University',
  'Western Nevada College',
  'Western Oregon University',
  'Western Seminary',
  'Western Texas College',
  'Westminster Theological Seminary',
  'Whatcom Community College',
  'Willesden College of Technology',
  'William Peace University',
  'Yakima Valley Community College',
  'York College of Pennsylvania',
  'Young Harris College',
  'Zane State College',
  'LaGuardia Community College',
  'Leicester College',
  'Lipscomb University',
  'Lokmanya Tilak College of Engineering',
  'London School of Economics and Political Science',
  'Lone Star College',
  'Los Angeles Community College District',
  'Los Angeles Harbor College',
  'Lower Columbia College ',
  'Lublin University of Technology',
  'Magadh University',
  'Malnad College of Engineering',
  'Manav Bharti University',
  'Medix College',
  'Melborne University of Technology',
  'Metropolitan College of New York',
  'Metropolitan State College of Denver',
  'Middlesex Community College',
  'Mildred Elley',
  'Millennia Atlantic University',
  'Minnesota School of Business',
  'Molloy College',
  'Monad University',
  'Monroe College',
  'Moolji Jetha College Jalgaon',
  'Moscow Automobile and Road Construction University',
  'Moscow State University of Civil Engineering',
  'Motiram Baburam Government Post Graduate College',
  'Mount Royal University',
  'MP Board Bhopal',
  'Municipal Manohar Junior College',
  'Muskingum College',
  'Nanyang Technological University',
  'National Business School',
  'National Institute of Technology',
  'National Institute of Technology and Science',
  'National Institute of Technology, Silchar',
  'National University of Benin',
  'Nazareth College',
  'New College',
  'New Hampshire Technical Institute',
  'Northeast Wisconsin Technical College',
  'Northeastern College, Trinidad West Indies',
  'Northern Alberta Institute of Technology',
  'Northern Arizona University',
  'Notre Dame University, Lebanon',
  'Nottingham Trent University',
  'NYU Polytechnic School',
  'Obafemi Awolowo University',
  'Odessa College',
  'Oklahoma City Community College',
  'Olabisi Onabanjo University',
  'Olean Business Institute',
  'Onondaga Community College',
  'Osmania University',
  'Pasco Hernando State College',
  'Patna University',
  'PC Age Career Institute',
  'Penn State University-University Park',
  'Piloo Mody College of Architecture',
  'Pilot University of Colombia',
  'Platt College',
  'Politecnico di Milano',
  'Prairie State College',
  'Punjab University, Chandigarh',
  'Purdue University Northwest',
  "Queen's University, Canada",
  'Queensborough Community College',
  'R.D.S. College BRABU Muzaffarpur',
  'R.M.L.S. College Muzaffarpur Bihar',
  'Rajiv Gandhi Proudyogiki Vishwavidyalaya, Bhopal',
  'Ranchi University',
  'Rani Durgavati Vishwavidyalaya',
  'Raritan Valley Community College',
  'Rashtrasant Tukadoji Maharaj Nagpur University',
  'Red River College',
  'Regent University',
  'Regents College',
  'Richard J Daley College',
  'RICS School of Built Environment',
  'Robert Gordon University',
  'Rochville University',
  'Rourkela Institute of Technology',
  'S.T.J. Institute of Technology - Karnatak University',
  "Saint Martin's University",
  'Salisbury University',
  'San Diego City College',
  'Santa Barbara City College',
  'Sardar Vallabhbhai National Institute of Technology, Surat',
  'Sauk Valley Community College',
  'Savitribai Phule Pune University',
  'Schenectady County Community College',
  'Schiller International University',
  'School of Planning and Architecture',
  'Sekolah Menengah Methodist ACS',
  'Seneca College',
  'Sepuluh Nopember Institute of Technology',
  'Seshasayee Institute of Technology',
  'Sewanee: The University of the South',
  'Sharda University',
  'Sheridan College',
  'Shivaji University',
  'Shobhit Institute of Engineering &amp; Technology',
  'Shorter College',
  'Sikkim Manipal University',
  'Skagit Valley College',
  'Somerset Community College',
  'South Piedmont Community College',
  'South Puget Sound Community College',
  'South Seattle Community College',
  'South Texas College of Law',
  'South Ural State University',
  'Southeast College of Technology',
  'Southeastern Louisiana University',
  'Southeastern Oklahoma State University',
  'Southern Alberta Institute of Technology',
  'Sree Krishna College',
  'Saint Petersburg Military Engineering-Technical University',
  'University of the Punjab',
  'Linköping University',
  'University of Western Australia',
  'Arba Minch University',
  'Aesthetic Science Institute',
  'University of Missouri - St. Louis',
  'Saint Vincent College',
  'Everest University',
  'Milwaukee Area Technical College',
  'Universidad del Valle de Mexico',
  'Escuela Bancaria y Comercial',
  'Terra State Community College',
  'Jackson State University',
  'William Penn University',
  'Central Carolina College',
  'University of Finance and Marketing',
  'University of Economics Ho Chi Minh',
  'University of New South Wales',
  'Infrastructure University Kuala Lumpur',
  'Sri Taralabalu Jagadguru Institute of Technology',
  'Rajamangala University of Technology Lanna',
  'Siam University',
  'George Fox University',
  'Ramkhamhaeng University',
  'Thai University',
  'South Gujarat University',
  'Negeri Institute of Technology',
  'University of Victoria',
  'Universiti Teknologi Petronas',
  'Grove City College',
  'Ashworth College',
  'La Universidad del Zulia',
  'Tribhuvan University',
  'Universidad Pontificia Bolivariana',
  'Hood College',
  'NED University of Engineering &amp; Technology',
  'Coleman University',
  'Indian Institute of Technology Bombay',
  'Rollins College, Crummer Graduate School of Business',
  'Total Technical Institute',
  'King Abdullah University of Science and Technology',
  'Clackamas Community College',
  'University of Alaska Anchorage',
  'University of San Diego',
  'Columbia State Community College',
  'Lake Michigan College',
  'Foreign Trade University',
  'SUNY Purchase',
  'University of Carabobo',
  'Heald Business College',
  'University of Chester',
  "Al Balqa' Applied University",
  'Florida Southern College',
  'Royal Melbourne Institute of Technology (RMIT)',
  'Front Range Community College',
  'South Dakota State University',
  'Sul Ross State University',
  'University of Finance - Marketing',
  'Massasoit Community College',
  'Escola De Engenharia Maua',
  'The University of Liverpool',
  'Des Moines Area Community College',
  'Santa Ana College',
  'Instituto Politecnico Nacional',
  'American Military University',
  'Damascus University',
  'St. John Technical College',
  'Nakornsithammarat Technical College',
  'Sripatum University',
  'Institute of Engineering, Trivandrum',
  'Thammasat University',
  'Polytechnic Port Dickson (PPD)',
  'Thakur Institute of Management Studies &amp;amp; Research',
  'Cumhuriyet University',
  'İstanbul Bilgi University',
  'New Jersey City University',
  'Licking County Joint Vocational School',
  'University of Rajasthan',
  'Southeast Community College',
  'Doane College',
  'Adichunchanagiri Institute of Technology',
  'Douglas College',
  'Westminster College, Salt Lake City',
  'Baker College',
  'SUNY Rockland Community College',
  'Yashwant Rao Chavan Maharashtra Open University',
  'Ohio Christian University',
  'Brazosport College',
  'College of Technology and Industrial Management (CTIM)',
  'Universidad Anahuac del Sur',
  'Charleston Southern University',
  'Blue Mountain College',
  'North East Mississippi Community College',
  'Universidad Autonoma de Chiapas',
  'Mansfield University of Pennsylvania',
  'University of Maryland Global Campus',
  'Philippine Women’s University',
  'Universidad Politecnica de Valencia España',
  'Tecnológico de Estudios Superiores de Ecatepec',
  'La Villa English Academies',
  'Linn Benton Community College',
  'National Labor College',
  'Kharkov University of Civil Engineering and Architecture',
  'Waubonsee Community College',
  'Gwinnett Technical College',
  'BS Abdur Rahman University',
  'Prist University',
  'Shri Adhishankarar Polytechnic College',
  'University of Charleston',
  'University of Saskatchewan',
  'Liaoning Technical University',
  'Renmin University of China',
  'Greenville Technical College',
  'William Jewell College',
  'State University of Jakarta',
  "Lycee d'Etat Rempart",
  'Bellevue University',
  'Central Oregon Community College',
  'Ramapo College of New Jersey',
  'Lakehead University',
  'Central Ohio Technical College',
  'Al-Mustansiryah University',
  'Wenatchee Valley Community College',
  'College of the Desert',
  "St. Joseph's College",
  'Centro Universitario Moura Lacerda',
  'Art Institute of Philadelphia',
  'CDI College',
  'Universidad Rafael Urdaneta',
  'Tennessee College of Applied Technology',
  'University of Kitakyushu',
  'Texas Southern University',
  "Hautes Etudes d'Ingenieurs",
  'University of Economic and Technical Industries',
  'SRM University',
  'Curtin University',
  'Da Nang University of Science and Technology',
  'University of Hawaii',
  'Eskisehir Osmangazi University',
  'Sakarya University',
  'Georgia College &amp;amp; State University',
  'Emmanuel College',
  'Central Community College',
  'Northwest Florida State College',
  'Lake Erie College',
  'Bossier Parish Community College',
  'Everett Community College',
  "The King's College",
  'Shepherd University',
  'Northeastern Illinois University',
  'University of Fraser Valley',
  'Algonquin College',
  'Cyprus Eastern Mediterranean University',
  'Akdeniz University',
  'Istanbul University',
  'Gebze Technical University',
  'Anadolu University',
  'Marmara University',
  'Beykent University',
  'Sri Sai Aditya Engineering College',
  'Tunku Abdul Rahman College',
  'Loughborough University',
  'Jan Evangelista Purkyne University',
  'Eskisehir Anadolu University',
  'Brno University of Technology',
  'Izmir University of Economics',
  'Istituto Europeo di Design',
  'Ton Duc Thang University',
  'University of Architecture Ho Chi Minh City',
  'Southern Arkansas University',
  'Harrisburg University of Science and Technology',
  'University Malaysia Pahang (UMP)',
  'Biola University',
  'Colorado Mesa University',
  'Ozarks Technical Community College',
  '&amp;nbsp;Western Colorado University',
  'Western Colorado University',
  'Universidad Centroamericana José Simeón Cañas',
  'Olivet Nazarene University',
  'Kugan &amp;amp; Associates, Inc.',
  'Hawaii Pacific University',
]
export const typeOfDegreeOptions = [
  'GED',
  'High School',
  'Certificate',
  "Associate's",
  "Bachelor's",
  "Master's",
  'Doctorate',
  'Other',
]
export const degreeOptions = [
  'Associates',
  'Associate of Arts',
  'Associate of Applied Science',
  'Associate of Business Admin',
  'Associate of Engineering',
  'Associate of Science',
  'Bachelors',
  'Bachelor of Arts',
  'Bachelor of Building Construction',
  'Bachelor of Business Admin',
  'Bachelor of Engineering',
  'Bachelor of Fine Arts',
  'Bachelor of Prof Studies',
  'Bachelor of Science',
  'Bachelor of Science - Law',
  'Bachelor of Theology',
  'Bachelor of Construction Mgmt.',
  'Bachelor of Architecture',
  'Diploma',
  'High School Graduate',
  'H.S. Diploma Equivalency',
  'Registered Nurse',
  'Trade School Graduate',
  'Juris Doctor',
  'Certificate',
  'Doctor of Business Admin',
  'Doctor of Philosophy',
  'Doctor of Engineering',
  'Doctor of Education',
  'Doctor of Medicine',
  'Doctor of Science',
  'Masters',
  'Master of Divinity',
  'Master of Education',
  'Master of Arts',
  'Master of Architecture',
  'Master of Business Admin',
  'Master of Bldg Construction',
  'Master of Civil Engineering',
  'Master of Engineering',
  'Master of Electrical Enginrg',
  'Master of Fine Arts',
  'Master of Human Resources',
  'Master of Legal Studies',
  'Master of Mechanical Enginrg',
  'Master of Public Administration',
  'Master of Project Management',
  'Master of Science',
  'Master of Science - Law',
  'Master of Social Work',
  'Master of Theology',
  'Master of Urban Planning',
  'Master of Communication',
  'Master of Public Health',
  'Non-Graduate',
  '0-Not Listed',
  'Some College',
  'Dipl. Ing',
  'Bachelor of Applied Administration',
  'Bachelor of Applied Science',
  'Bachelor of Architectural Engineering',
  'Bachelor of Commerce',
  'Bachelor of Design',
  'Bachelor of Engineering, Honours',
  'Bachelor of Environmental Design',
  'Bachelor of Music',
  'Bachelor of Science Housing Building & Planning, Honours',
  'Intermediate of Science',
  'Journeyman',
  'Master of Accountancy',
  'Master of Building Engineering & Management',
  'Master of Computer Applications',
  'Master of Labour Laws and Personnel Management',
  'Master of Philology',
  'Bachelor of Quantity Surveying',
  'Bachelor of Business English',
  'Associate of Occupational Studies',
  'Technology Management',
  'Master of Industrial Engineering',
  'Bachelor of Industrial Engineering',
  'Post Doctorate',
  'Executive Masters',
  'Accounting Technical Career',
  'Bachelors of Information Technology and Security',
  'Bachelor of Urban Planning',
  'Bachelor of Landscape Architecture',
  'Master of Architectural Engineering',
  'Advanced Diploma in Technology Building',
  'Postgraduate Diploma',
  'Executive Master in Safety, Health and Environment',
]
export const majorOptions = [
  'Construction Management Tech',
  'High School',
  'Military Strategy',
  'Neuroscience',
  'Earth Science',
  'Civil Engineering',
  'Mechanical Engineering',
  'Accounting',
  'Adm/Just+Publ Safety',
  'Administration/Higher Edu',
  'Advanced Technical Studies',
  'Aerospace Engineering',
  'Agriculture Business',
  'Agriculture Development',
  'Animal Sciences',
  'Anthropology',
  'Architectual Design',
  'Architectual Drafting',
  'Architectual Technology',
  'Architectural Conservation',
  'Architectural Engineering Technology',
  'Architectural History',
  'Architecture',
  'Architecture-Environmental Studies',
  'Architecural Engineering',
  'Art Education',
  'Art History',
  'Arts &amp; Aesthetics',
  'Astronautical Engineer',
  'Audio/Video Engineering',
  'Bachelor of Applied Management',
  'Bio Chemical',
  'Biology',
  'Building Construction',
  'Building Science',
  'Business Administration',
  'Business Economics',
  'Business Logistics',
  'Business Management',
  'Chemical Engineer',
  'Chemistry',
  'Civil Infrastructure Systems',
  'Civil Technology',
  'Classical Studies',
  'Commercial &amp; Engineering',
  'Communications',
  'Communications and Training',
  'Computer Science',
  'Concrete Industry Management',
  'Construction',
  'Construction Administration',
  'Construction Engineering',
  'Construction Engineering Technology',
  'Construction Management',
  'Construction Science',
  'Construction System Management',
  'Construction Technology',
  'Contract Engineering',
  'Counseling',
  'Creative Writing',
  'Criminal Justice',
  'Culinary Arts',
  'Cultural History',
  'Data Processing',
  'Design',
  'Drama/Music',
  'Historic Preservation',
  'History',
  'History of Science &amp; Medicine',
  'Human Relations',
  'Human Resources Management',
  'Humanities',
  'Industrial Engineering',
  'Industrial Hygiene',
  'Industrial Management',
  'Industrial Technology',
  'Information Systems',
  'Insurance',
  'Integrated Business and Engineering',
  'Interior Design',
  'International Affairs',
  'Journalism',
  'Labor and Industrial Relations',
  'Land Development',
  'Landscape Architecture',
  'Law',
  'Legal Translation',
  'Liberal Arts',
  'Literature',
  'Logistics &amp; International Business',
  'Management',
  'Management Technology',
  'Marine Engineering',
  'Marketing',
  'Master of Computer Applications',
  'Mathematics',
  'Mechanical Technology',
  'Mining Engineering',
  'Multimedia Technology',
  'Museum Studies',
  'Music',
  'Nutrional Science',
  'Oceanography',
  'Office Technology',
  'Operations Research',
  'Organizational Management',
  'Paralegal',
  'Philosophy',
  'Physics',
  'Planning',
  'Political Science',
  'Pre Med',
  'Psychology',
  'Public Admin',
  'Public Relations',
  'Quantitative Analysis',
  'Quantity Surveying',
  'Real Estate Developer',
  'Recreation Management',
  'Safety',
  'Safty &amp; Health',
  'Science',
  'Secretarial',
  'Security Administration',
  'Social and Behavorial Science',
  'Social Work',
  'Sociology',
  'Statistics',
  'Studio Art',
  'Telecommunication Mgmt',
  'Telecommunications',
  'Textiles',
  'Theology',
  'Travel &amp; Tourism',
  'Urban Administration',
  'Urban Planning',
  'Visual Arts',
  'Wood Products Engineering',
  'Word Processing',
  '0-Not Applicable',
  'Unspecified',
  'Economic Development',
  'Economics',
  'Education',
  'Education Psychology',
  'Engineering Science',
  'English',
  'Environmental Design',
  'Environmental Engineering',
  'Environmental Management',
  'Environmental Science',
  'Environmental Studies',
  'Finance',
  'Fine Arts',
  'Foreign Languages',
  'General Studies',
  'Geographic Information Systems',
  'Geology',
  'Government',
  'Graphic Communications',
  'Graphics Design',
  'Structural Engineering',
  'Advertising',
  'Air Conditioning and Refrigeration',
  'Airframe and Powerplant',
  'Applied Management',
  'Applied Thermodynamics',
  'Architectural Design &amp; Building',
  'Arts Entrepreneurship',
  'Autobody, Painting, and Management',
  'Biochemical Regulatory Engineering',
  'Building',
  'Building Services Engineering',
  'Business',
  'Business Analytics and Information Technology',
  'Carpentry',
  'Chicano Latino Studies',
  'Civil &amp; Environmental Engineering',
  'Civil Engineering Technology',
  'Cognitive Science',
  'Commerce',
  'Compliance',
  'Computer Application',
  'Construction Engineering and Management',
  'Construction Engineering and Project Management',
  'Construction Project Management',
  'Construction Science and Management',
  'Corporate Communications and Public Affairs',
  'Court Reporting',
  'Educational Technology',
  'Electrical',
  'Electrical &amp; Electronic Controls',
  'Electrical and Electronic Engineering',
  'Electrical Engineering',
  'Elementary Education',
  'Emergency Medical Services - Paramedic',
  'Engineering and Public Policy',
  'Engineering Physics',
  'Entrepreneurship',
  'Environmental Health &amp; Safety',
  'Facilities Engineering',
  'Family and Consumer Science',
  'Fire Science',
  'Forensic Psychology',
  'General Science',
  'German',
  'Health Care Management',
  'Hospitality Management',
  'Industrial Organizational Psychology',
  'Industrial Safety Management',
  'Infrastructure and Finance Studies',
  'Interdisciplinary Design-Built Env.',
  'Japanese',
  'Leadership',
  'Lean Advancement Initiatives',
  'Literature',
  'Marine Transportation',
  'Maritime Administration',
  'Marketing Communications',
  'Masonary',
  'Mechatronics Engineering',
  'Media Arts and Animation',
  'Media Management',
  'Media Studies',
  'Medical Administration',
  'Music Education',
  'Naval Architecture and Ocean Engineering',
  'Occupational Safety &amp; Health',
  'Office Administration',
  'Operations Research',
  'Organizational Behavior',
  'Organizational Leadership',
  'Organizational Management',
  'Pharmacy',
  'Philosophy',
  'Photography',
  'Pipefitting',
  'Project Management',
  'Public Health',
  'Real Estate',
  'Real Estate and Business Foundations',
  'Refrigeration Mechanic',
  'Regional and City Planning',
  'Restoration',
  'Risk Management',
  'Safety &amp; Fire Fighting',
  'Spanish',
  'Specialist in International Relations',
  'Strategic Management',
  'Supply Chain Management',
  'Surveying and Mapping',
  'Sustainable Business',
  'Sustainable Engineering',
  'Systems Engineering',
  'Taxation',
  'Thermal Engineering',
  'Urban Regeneration',
  'Water Resourse Engineering',
  'Welding',
  'Real Estate and Infrastructure',
  'Physical Education',
  'Mass Communication',
  'Human Rights',
  'Construction and Facilities Management',
  'South Asian Studies',
  'Physical Science',
  'Human Resource Development',
  'Legal Office Systems',
  'Science &amp; Technology Studies',
  'Sustainable Construction',
  'Logistics and Supply Chain Management',
  'Crisis Management Community Resilience',
  'Emergency &amp;amp; Disaster Management',
  'Aerospace Science',
  'Sustainability',
  'Computer Networks and Cybersecurity',
  'Humanitarian Engineering',
  'Asian Studies',
  'Civil Engineering and Management',
  'Geophysical Engineering',
  'General Engineering',
  'Healthier Materials and Sustainable Buildings',
  'Lighting Engineering',
  'Construction Finance Management',
  'Offshore Engineering',
  'Nuclear Engineering',
  'Disaster Management',
  'Community Development',
  'Geography',
  'Dance',
  'Applied Mathematics',
  'Health Behavior',
  'Horticulture',
]
export const issuingStateOptions = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
]
